import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import Login from './components/login';
import SignUp from './components/signup';
import { IProps } from './type';
import HelmetNoIndex from '../../shared/components/helmet-no-index';
import ThirdPartyIntegrations from '../../shared/third-party-integrations';
import Suspense from '../../shared/components/suspense';
import retryLazy from '../retry-lazy';

const ResetPassword = React.lazy(() =>
  retryLazy(() => import('./components/reset-password')),
);
const ChangePassword = React.lazy(() =>
  retryLazy(() => import('./components/change-password')),
);
const AcceptInvitationSignup = React.lazy(() =>
  retryLazy(() => import('./components/invitation-signup')),
);
const OnBoarding = React.lazy(() =>
  retryLazy(() => import('./components/on-boarding')),
);
const ConnectEmailAccount = React.lazy(() =>
  retryLazy(() => import('./components/connect-email-account')),
);
const UserOnboarding = React.lazy(() =>
  retryLazy(() => import('./components/user-onboarding')),
);
const AccountDetails = React.lazy(() =>
  retryLazy(() => import('./components/account-details')),
);
const LTDSignup = React.lazy(() =>
  retryLazy(() => import('./components/ltd-signup')),
);
const LTDCheckout = React.lazy(() =>
  retryLazy(() => import('./components/ltd-checkout')),
);

const Auth: React.FC<IProps> = ({ sendGetAgencyConfigRequest }) => {
  const agencyConfigPayload = {
    baseUrl: window.location.origin,
  };

  useEffect(() => {
    sendGetAgencyConfigRequest(agencyConfigPayload);
  }, []);

  // useEffect(() => {
  //   if (window.Intercom) {
  //     try {
  //       window.Intercom('boot', {
  //         api_base: supportUrls.intercomBaseUrl,
  //         app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  //       });
  //     } catch (error) {
  //       console.warn('Failed to boot Intercom:', error);
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   if (window.Intercom) {
  //     try {
  //       window.Intercom('event', {
  //         type: HelpscoutBeaconEvents.PAGE_VIEWED,
  //         url: document.location.href,
  //         title: document.title,
  //       });
  //       window.Intercom(HelpscoutBeaconEvents.SUGGEST);
  //     } catch (error) {
  //       console.warn('Failed to send Intercom events:', error);
  //       // Continue execution even if Intercom fails
  //     }
  //   }
  // }, [window.Intercom, document.location.href]);

  return (
    <div className="auth-page-container">
      <HelmetNoIndex />

      <Suspense>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/signup" component={SignUp} />
          <Route path="/LTD-Signup" component={LTDSignup} />
          <Route path="/LTD-Checkout" component={LTDCheckout} />
          <Route path="/user-onboarding" component={UserOnboarding} />
          <Route path="/welcome" component={AccountDetails} />
          <Route path="/verify-account" component={UserOnboarding} />
          <Route exact path="/onboarding-form" component={OnBoarding} />
          <Route exact path="/set-password" component={ChangePassword} />
          <Route
            exact
            path="/connect-account"
            component={ConnectEmailAccount}
          />
          <Route
            exact
            path="/reset-password/:code"
            component={ChangePassword}
          />
          <Route
            exact
            path="/accept-invite/:token"
            component={AcceptInvitationSignup}
          />
          <Route exact path="/reset-password" component={ResetPassword} />
        </Switch>
      </Suspense>
      <ThirdPartyIntegrations
        enableHighAdvocacy={false}
        enableChurnKey={false}
        enablePaddle={false}
        enableCustomerio={false}
        enableBetterBugs={false}
      />
    </div>
  );
};

export default Auth;
